class TrudoorMainProduct extends HTMLElement {
  constructor() {
    super();
    this.handleVariantChange = this.handleVariantChange.bind(this);
  }

  connectedCallback() {
    this.addEventListener("variant:change", this.handleVariantChange);
    this.refreshUsuallyShips();
  }

  async refreshUsuallyShips() {
    const form = this.querySelector("trudoor-product-form");
    if (!form) return;
    const button = document.querySelector("[type=submit]#add");
    // WHY: the sticky bar's simple (single-variant) button also captures usually_ships
    // at click time, so it must be locked during the refresh just like #add.
    // The .simple class excludes multi-variant buttons, whose click is scroll-up, not ATC.
    const stickyButton = document.querySelector("#sticky-add-to-cart-button.simple");
    if (button) button.disabled = true;
    if (stickyButton) stickyButton.disabled = true;
    try {
      const response = await fetch(
        `${window.location.pathname}?variant=${form.dataset.variantId}&section_id=${this.dataset.sectionId}`,
      );
      if (!response.ok) return;
      const html = new DOMParser().parseFromString(await response.text(), "text/html");
      const freshForm = html.querySelector("trudoor-product-form");
      if (!freshForm) return;

      const freshValue = freshForm.dataset.variantUsuallyShips;
      if (freshValue !== undefined) {
        if (freshValue !== form.dataset.variantUsuallyShips) {
          form.dataset.variantUsuallyShips = freshValue;
          const hiddenInput = form.closest("form")?.querySelector('input[name="properties[Usually Ships]"]');
          if (hiddenInput) hiddenInput.value = freshValue;
        }
        // WHY: the sticky button reads its own data-product-ships, baked in at
        // CDN-cache time and never otherwise refreshed. Sync it to the fresh value
        // unconditionally — cached HTML may have omitted the attribute entirely
        // (metafield was blank at cache time), so attribute absence is also stale.
        if (stickyButton) {
          if (freshValue) {
            stickyButton.dataset.productShips = freshValue;
          } else {
            delete stickyButton.dataset.productShips;
          }
        }
      }
    } catch {
      // Silent — stale value is better than broken cart
    } finally {
      if (button) button.disabled = false;
      if (stickyButton) stickyButton.disabled = false;
    }
  }

  async handleVariantChange(event) {
    if (!event.detail?.variant) return;

    const variant = event.detail.variant;
    const loadingId = this.id;

    // Update URL
    const newUrl = new URL(window.location);
    newUrl.searchParams.set("variant", variant.id);
    window.history.replaceState({}, "", newUrl);

    // Show loading state
    LoadingManager.show({ elementId: loadingId });

    try {
      const response = await fetch(
        `${window.location.pathname}?variant=${variant.id}&section_id=${this.dataset.sectionId}`,
      );
      const html = await response.text();

      const parser = new DOMParser();
      const newDocument = parser.parseFromString(html, "text/html");
      const newSection = newDocument.querySelector("#trudoor-main-product");

      if (newSection) {
        this.replaceWith(newSection);
      }
    } catch (error) {
      console.error("Error updating product section:", error);
    } finally {
      LoadingManager.hide({ elementId: loadingId });
      if (event.detail.onComplete) event.detail.onComplete();
    }
  }
}

customElements.define("trudoor-main-product", TrudoorMainProduct);
